var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22 13.6416C22 19.1646 17.523 23.6416 12 23.6416C6.477 23.6416 2 19.1646 2 13.6416C2 8.1196 6.477 3.6416 12 3.6416C17.523 3.6416 22 8.1196 22 13.6416Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0299 14.3882L9.97007 15.0115V11.8948L13.0299 11.2715V14.3882ZM16 10.6666V10.1165L13.57 10.6115V7.6416H13.0299V10.7215L9.97007 11.3448V7.6416H9.43002V11.4549L7 11.9499V12.4999L9.43002 12.0049V15.1216L7 15.6166V16.1667L9.43002 15.6717V18.6416H9.97007V15.5617L13.0299 14.9384V18.6416H13.57V14.8283L16 14.3333V13.7833L13.57 14.2783V11.1616L16 10.6666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTag);
export default __webpack_public_path__ + "static/media/hash_tag.a8deafda90a13e16d076d77ffdd21819.svg";
export { ForwardRef as ReactComponent };